export const listButtons = {
  multiservice: [
    {
      title: "ASESORÍA LEGAL",
      url: "/conventions/multi-service/legal-advice",
    },
    {
      title: "EMPRESAS",
      url: "/conventions/multi-service/companies",
    },
    {
      title: "FINANCIERAS",
      url: "/conventions/multi-service/financials",
    },
    {
      title: "HOTELES",
      url: "/conventions/multi-service/hotel",
    },
    {
      title: "SALUD",
      url: "/conventions/multi-service/health",
    },
    {
      title: "SEGUROS",
      url: "/conventions/multi-service/life-insurance",
    },
    {
      title: "RESTAURANTES",
      url: "/conventions/multi-service/restaurants",
    },
    {
      title: "TECNOLOGÍA",
      url: "/conventions/multi-service/technology",
    },
    {
      title: "TRANSPORTES",
      url: "/conventions/multi-service/transport",
    },
    {
      title: "BANCOS",
      url: "/conventions/multi-service/banks",
    },
    {
      title: "AUTOMÓVILES",
      url: "/conventions/multi-service/automobiles",
    },
    {
      title: "ENTRETENIMIENTO",
      url: "/conventions/multi-service/entertainment",
    },
  ],
  education: [
    {
      title: "UNIVERSIDADES",
      url: "/conventions/education-conventions/universities",
    },
    {
      title: "INSTITUTOS",
      url: "/conventions/education-conventions/institutes",
    },
    {
      title: "SOLICITA TU CONVENIO",
      urlWeb: "https://korekenke.mil.pe/",
    },
    {
      title: "VIDEOS TUTORIAL",
      url: "/conventions/education-conventions/videos-tutorial",
    },
  ],
  province: [
    {
      title: " PIURA - SULLANA",
      url: "/conventions/provinces/piura-sullana",
    },
    {
      url: "/conventions/provinces/tacna",
      title: "TACNA",
    },
    {
      url: "/conventions/provinces/puno",
      title: "PUNO",
    },
    {
      title: "TRUJILLO",
      url: "/conventions/provinces/trujillo",
    },
    {
      title: "TUMBES",
      url: "/conventions/provinces/tumbes",
    },
    {
      title: "AYACUCHO",
      url: "/conventions/provinces/ayacucho",
    },
    {
      title: "CHICLAYO",
      url: "/conventions/provinces/chiclayo",
    },
    {
      title: "HUANCAYO",
      url: "/conventions/provinces/huancayo",
    },
    {
      title: "AREQUIPA",
      url: "/conventions/provinces/arequipa",
    },
    {
      title: "LA MERCED",
      url: "/conventions/provinces/merced",
    },
    {
      title: "LAMBAYEQUE",
      url: "/conventions/provinces/lambayeque",
    },
    {
      title: "TARAPOTO",
      url: "/conventions/provinces/tarapoto",
    },
  ],
};
